import { createStore, applyMiddleware } from 'redux'
import { createLogger } from 'redux-logger'

import rootReducer from './reducers'

if (typeof window === 'undefined') {
    global.window = {}
}

const middleware = []

// show logs only in dev
if (process.env.NODE_ENV === 'development') {
    const loggerMiddleware = createLogger()
    middleware.push(loggerMiddleware)
}

// export default store
export default createStore(rootReducer, applyMiddleware(...middleware))



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/connectors/redux/index.js